import { cx } from 'cva';
import {
  FieldError as AriaFieldError,
  type FieldErrorProps as AriaFieldErrorProps,
} from 'react-aria-components/FieldError';

import styles from './field_error.module.css';

/** Field validation error message. */
export function FieldError({
  className,
  ...props
}: Omit<AriaFieldErrorProps, 'className'> & { className?: string }) {
  return (
    <AriaFieldError {...props} className={cx(styles.field_error, className)} />
  );
}
